import { WavesModule, SelectModule, ToastService } from 'ng-uikit-pro-standard';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IMyOptions } from 'ng-uikit-pro-standard';
// tables
import { Component, OnInit, ElementRef, HostListener, AfterViewInit, ViewChild, ChangeDetectorRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MdbTableDirective, MdbTablePaginationComponent } from 'ng-uikit-pro-standard';
import { CustomerService } from 'src/app/services/customer.service';
import { GeneralService } from 'src/app/services/general.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
declare var $: any;
import * as AspNetData from "devextreme-aspnet-data-nojquery";
import { MapInformationService } from 'src/app/services/map-information.service';
import { AppConfigService } from 'src/app/app-config.service.service';
import { AnonymousSubject } from 'rxjs/internal/Subject';
import {DatePipe, Location} from '@angular/common';
import CustomStore from 'devextreme/data/custom_store';
import DataGrid from "devextreme/ui/data_grid";
import Popup from 'devextreme/ui/popup';
import { DxSelectBoxComponent } from 'devextreme-angular';
@Component({
  selector: 'edit-customer-reutilizable',
  templateUrl: './edit-customer-reutilizable.component.html',
  styleUrls: ['./edit-customer-reutilizable.component.scss']
})
export class EditCustomerReutilizableComponent implements OnInit, OnChanges {
  @ViewChild(MdbTableDirective, { static: true }) mdbTable: MdbTableDirective;
  @ViewChild(MdbTablePaginationComponent, { static: true }) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild("newRequestBySelect", { static: false }) newRequestBySelect: DxSelectBoxComponent;
  @ViewChild('row', { static: true }) row: ElementRef;
  @Input() VieneDe: any;
  @Input() customerID: any;
  optionsPerson: Array<any>;
  optionsCType: Array<any>;
  optionSregion: Array<any>;
  optionsCity: Array<any>;
  optionsState: Array<any>;
  optionsZip: Array<any>;
  elements: any = [];
  elements2: any = [];
  elements3: any = [];
  elements4: any = [];
  elements5: any = [];
  elements6: any = [];
  elements7: any = [];
  optionsCode = [];
  optionsSize = [];
  optionsRating = [];
  customerFilter = {
    PageIndex: 1,
    PageSize: 20,
    OrderID: 1,
    Id: 0,
    CustomerName: '',
    CustomerNumber: '',
    SalesPerson: '',
    CustomerType: '',
    SalesRegion: '',
    City: '',
    State: '',
    Zip: '',
    OfficePhone: '',
    HasCredit: '',
    Active: '',
    OffFax: ''
  };
  customerTypeSelect: any = [];
  modelCustomerType: any = [];
  salesPersonSelect: any = [];
  contrySelect: any = [];
  modelSalesPerson: any = [];
  customers: any = [];
  lastSearchZero: boolean = false;
  loading: boolean = false;

  deleteContacSelect: any;
  namedeleteContacSelect: any;

  viewDashboardType = 0;

  activo: boolean = true
  millisecondsInDay = 24 * 60 * 60 * 1000;
  filterValue: any
  customOperations: Array<any>;
  popupPosition: any;

  /**
   * Form new custumer vars
   */
  public _formEntity: FormGroup;
  public _formEntityEdit: FormGroup;
  public _formEntityAssociatePeople: FormGroup;
  public _formEntityActivity: FormGroup;
  public _showBillingAddress: boolean;
  options = [
    { value: '1', label: 'Option 1' },
    { value: '2', label: 'Option 2' },
    { value: '3', label: 'Option 3' },
  ];
  //End Form new custumer

  public myDatePickerOptions: IMyOptions = {
    // Your options
  };

  // Head tables
  headElements = [{ head: 'Contact Name', id: 'EstimateId', class: 'text-left' },
  { head: 'Company', id: 'ProjectName', class: 'text-left' }
  ];

  headElements2 = [{ head: 'Project Number', id: 'EstimateId', class: 'text-right' },
  { head: 'Project Name', id: 'ProjectName', class: 'text-left' },
  { head: 'Quote Date', id: 'Category', class: 'text-right' },
  { head: 'Project Amount ', id: 'VerticalMarket', class: 'text-right' }
  ];


  headElements6 = [{ head: 'Project Number', id: 'EstimateId', class: 'text-right' },
  { head: 'Project Name', id: 'ProjectName', class: 'text-left' },
  { head: 'Quote Date', id: 'Category', class: 'text-right' },
  { head: 'Project Amount', id: 'VerticalMarket', class: 'text-right' }

  ];

  public chartType: string = 'line';

  public chartDatasets: Array<any> = [
    { data: [65, 59, 80, 81, 56, 55, 40], label: 'My First dataset' },
    { data: [28, 48, 40, 19, 86, 27, 90], label: 'My Second dataset' }
  ];

  public chartLabels: Array<any> = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];

  public chartColors: Array<any> = [
    {
      backgroundColor: 'rgba(105, 0, 132, .2)',
      borderColor: 'rgba(200, 99, 132, .7)',
      borderWidth: 2,
    },
    {
      backgroundColor: 'rgba(0, 137, 132, .2)',
      borderColor: 'rgba(0, 10, 130, .7)',
      borderWidth: 2,
    }
  ];

  public chartOptions: any = {
    responsive: true
  };
  headers: any;
  public chartClicked(e: any): void { }
  public chartHovered(e: any): void { }


  // bar
  public chartType2: string = 'bar';

  public chartDatasets2: Array<any> = [
    { data: [65, 59, 80, 81, 56, 55, 40], label: 'My First dataset' }
  ];

  public chartLabels2: Array<any> = ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'];

  public chartColors2: Array<any> = [
    {
      backgroundColor: [
        'rgba(255, 99, 132, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(255, 206, 86, 0.2)',
        'rgba(75, 192, 192, 0.2)',
        'rgba(153, 102, 255, 0.2)',
        'rgba(255, 159, 64, 0.2)'
      ],
      borderColor: [
        'rgba(255,99,132,1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(153, 102, 255, 1)',
        'rgba(255, 159, 64, 1)'
      ],
      borderWidth: 2,
    }
  ];

  public chartOptions2: any = {
    responsive: true
  };
  public chartClicked2(e: any): void { }
  public chartHovered2(e: any): void { }


  // horizontal
  public chartType3: string = 'horizontalBar';

  public chartDatasets3: Array<any> = [
    { data: [65, 59, 80, 81, 56, 55, 40], label: 'My First dataset' }
  ];

  public chartLabels3: Array<any> = ['Red', 'Blue', 'Yellow'];

  public chartColors3: Array<any> = [
    {
      backgroundColor: [
        'rgba(255, 99, 132, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(255, 206, 86, 0.2)'

      ],
      borderColor: [
        'rgba(255,99,132,1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)'

      ],
      borderWidth: 2,
    }
  ];

  public chartOptions3: any = {
    responsive: true
  };

  public chartClicked3(e: any): void { }
  public chartHovered3(e: any): void { }
  dateFormat1: any


  customerDataSource: any;
  customerSelecte: any;
  dataCardList: any[] = []
  todayButtonreqDate: any;
  prevDateButtonreqDate: any;
  nextDateButtonreqDate: any;
  reqDate: number
  optionsRegion: any[] = []
  optionsTax: any[] = []
  optionsSalesPerson: any[] = []
  houseNumber: any = ""
  street: any = ""
  mapCity: any = ""
  mapState: any = ""
  mapcountry: any = ""
  mapPaostalCode: any = ""

  houseNumberBilling: any = ""
  streetBilling: any = ""
  mapCityBilling: any = ""
  mapStateBilling: any = ""
  mapcountryBilling: any = ""
  mapPaostalCodeBilling: any = ""

  contadorPaginacion: number = 1
  page: number = 1;

  cancelButtonFilter: any
  saveButtonFilter: any
  cancelButtonFilterActivity: any
  saveButtonFilterActivity: any
  workcompleteddate: number;
  todayButton: any;
  prevDateButton: any;
  nextDateButton: any;

  followUpDate: number;
  todayButtonfollowUpDate: any;
  prevDateButtonfollowUpDate: any;
  nextDateButtonfollowUpDate: any;
  addProdSpeButton:any
  popupActivityType:boolean=false
  nombreActivity:any="New Activity"


  constructor(
    private customerService: CustomerService,
    private generalService: GeneralService,
    public fb: FormBuilder,
    private router: Router,
    private toast: ToastService,
    public MapInformationService: MapInformationService,
    public appConfigService: AppConfigService,
    private location: Location,
    private pipeDate: DatePipe,) {

    // vista modal movil

    Popup.defaultOptions({
          device: { deviceType: "phone" },
          options: {
            fullScreen: true,

          }
        });
    // vista grid movil
    DataGrid.defaultOptions({
         device: { deviceType: "phone" },
         options: {
           columnAutoWidth: true,
           columnHidingEnabled: true,
           wordWrapEnabled: false,
           rowAlternationEnabled: false
           // showRowLines: true,
           // showColumnLines: false,
           // focusedRowEnabled: true,
           // allowColumnResizing: true,
           // noDataText: "",
           // scrolling: {
           //   mode: "virtual"
           // },
           // sorting: {
           //   mode: "single"
           // },
           // loadPanel: {
           //   enabled: false
           // }
         }
       });

       DataGrid.defaultOptions({
      device: { deviceType: "desktop" },
      options: {
        // columnAutoWidth: true,
        // columnHidingEnabled: false
        // showRowLines: true,
        // showColumnLines: false,
        // focusedRowEnabled: true,
        // allowColumnResizing: true,
        // noDataText: "",
        // scrolling: {
        //   mode: "virtual"
        // },
        // sorting: {
        //   mode: "single"
        // },
        // loadPanel: {
        //   enabled: false
        // }
      }
    });

    this.dateFormat1 = this.appConfigService.dateFormat
    this.customerSelecte = null;
    this.workcompleteddate = new Date().getTime();
    this.followUpDate = new Date().getTime();

      this.todayButtonfollowUpDate = {
        text: "Today",
        elementAttr: {
          id: 'today-Btn'
        },
        onClick: () => {
          this.followUpDate = new Date().getTime();
        }
      };

      this.prevDateButtonfollowUpDate = {
        icon: "spinprev",
        stylingMode: "text",
        onClick: () => {
          console.log(this.followUpDate)
          this.followUpDate -= this.millisecondsInDay;
        }
      };

      this.nextDateButtonfollowUpDate = {
        icon: "spinnext",
        stylingMode: "text",
        onClick: () => {
          console.log(this.followUpDate)
          this.followUpDate += this.millisecondsInDay;
        }
      };

    this.todayButton = {
      text: "Today",
      elementAttr: {
        id: 'today-Btn'
      },
      onClick: () => {
        this.workcompleteddate = new Date().getTime();
      }
    };

    this.prevDateButton = {
      icon: "spinprev",
      stylingMode: "text",
      onClick: () => {
        console.log(this.workcompleteddate)
        this.workcompleteddate -= this.millisecondsInDay;
      }
    };

    this.nextDateButton = {
      icon: "spinnext",
      stylingMode: "text",
      onClick: () => {
        console.log(this.workcompleteddate)
        this.workcompleteddate += this.millisecondsInDay;
      }
    };

    this.cancelButtonFilter = {
      text: 'Cancel',
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        this.CloseNewAssociatePeopple()
      },
    };

    this.saveButtonFilter = {
      text: 'Save',
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        this.SaveNewAssociatePeople()
      },
    }

    this.cancelButtonFilterActivity = {
      text: 'Cancel',
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        this.CloseNewActivity()
      },
    };

    this.saveButtonFilterActivity = {
      text: 'Save',
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        this.SaveNewActivity()
      },
    }

    this.todayButtonreqDate = {
      text: "Today",
      elementAttr: {
        id: 'today-Btn'
      },
      onClick: () => {
        this.reqDate = new Date().getTime();
      }
    };

    this.prevDateButtonreqDate = {
      icon: "spinprev",
      stylingMode: "text",
      onClick: () => {
        this.reqDate -= this.millisecondsInDay;
      }
    };

    this.nextDateButtonreqDate = {
      icon: "spinnext",
      stylingMode: "text",
      onClick: () => {
        this.reqDate += this.millisecondsInDay;
      }
    };
    this.addProdSpeButton = {
      icon: "edit",
      type: "button",
      onClick: () => {
        this.popupActivityType = true;
      },
    };
    this.initForm()


    this._formEntity = fb.group({
      CustomerName: [null, [Validators.required, Validators.maxLength(45)]],
      CustomerNumber: [null, []],
      CustomerTpeId: [{ value: 12, disabled: false }, []],
      OffPhone: [null, [Validators.maxLength(20)]],
      OffFax: [null, [Validators.maxLength(20)]],
      WebSite: [null, []],
      Address: [null, []],
      City: [null, []],
      Zip: [null, []],
      EmployeeId: [{ value: 1, disabled: false }, []],
      State: [null, []],
      Country: [{ value: 'USA', disabled: false }, []],
      Billing: [null, []],
      Notes: [null, []],
      BillingName: [null, [Validators.maxLength(50)]],
      BillingAddress: [null, []],
      BillingCity: [null, []],
      BillingZip: [null, []],
      BillingState: [null, []],
      BillingCountry: [{ value: 'USA', disabled: false }, []],
    });
    this._showBillingAddress = true;
    this.deleteContacSelect = null;
    this.namedeleteContacSelect = null;
  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes)
    if (this.VieneDe == "Customer") {
      if (changes.customerID != undefined) {
        this.customerID = changes.customerID.currentValue
        this.initForm()
        this.workcompleteddate = new Date().getTime();

        this.todayButton = {
          text: "Today",
          elementAttr: {
            id: 'today-Btn'
          },
          onClick: () => {
            this.workcompleteddate = new Date().getTime();
          }
        };

        this.prevDateButton = {
          icon: "spinprev",
          stylingMode: "text",
          onClick: () => {
            console.log(this.workcompleteddate)
            this.workcompleteddate -= this.millisecondsInDay;
          }
        };

        this.nextDateButton = {
          icon: "spinnext",
          stylingMode: "text",
          onClick: () => {
            console.log(this.workcompleteddate)
            this.workcompleteddate += this.millisecondsInDay;
          }
        };
        this.searchInfoToSelect()
      }
    }
    console.log("aqui")
  }

  ngOnInit() {
    const customerdata = JSON.parse(localStorage.getItem('customerData'));
    const customerfilter = JSON.parse(localStorage.getItem('customerFilter'));
    console.log(customerfilter)
    if (customerfilter) {
      this.customerFilter = customerfilter;
      this.modelCustomerType = this.customerFilter.CustomerType.split(',').map(item => {
        const el = parseInt(item, 10);
        if (!isNaN(el)) {
          return el;
        }
      });
      this.modelSalesPerson = this.customerFilter.SalesPerson.split(',').map(item => {
        const el = parseInt(item, 10);
        if (!isNaN(el)) {
          return el;
        }
      });
    }

    this.customerFilter.PageIndex = 1;
    this.GetCustomersWithFilters();

    this.GetSalesPerson();
    this.GetCustomerType();
    this.GetCountries();
    this.elements.push({ EstimateId: '5539', ProjectName: '2992', Category: 'Royal Concrete Concepts', VerticalMarket: 'Jose Smith', Status: 'Mechanical Contractor', Date: 'West Palm', city: 'Miami', state: 'Florida', zip: '32127', oficPhone: '386-252-12-22', oficFax: '305-555-888' });
    this.elements.push({ EstimateId: '5540', ProjectName: '2993', Category: '44 North', VerticalMarket: 'Jose Smith', Status: 'Mechanical Contractor', Date: 'West Palm', city: 'Miami', state: 'Florida', zip: '32127', oficPhone: '386-252-12-22', oficFax: '305-555-888' });
    this.elements.push({ EstimateId: '5541', ProjectName: '2994', Category: 'Adams', VerticalMarket: 'Jose Smith', Status: 'Mechanical Contractor', Date: 'West Palm', city: 'Miami', state: 'Florida', zip: '32127', oficPhone: '386-252-12-22', oficFax: '305-555-888' });
    this.elements.push({ EstimateId: '5542', ProjectName: '2995', Category: 'ABC Controls', VerticalMarket: 'Jose Smith', Status: 'Mechanical Contractor', Date: 'West Palm', city: 'Miami', state: 'Florida', zip: '32127', oficPhone: '386-252-12-22', oficFax: '305-555-888' });

    this.elements2.push({ EstimateId: '5567', ProjectName: 'Using cube resources', Category: '04/04/2019', VerticalMarket: '113,000.00' });
    this.elements2.push({ EstimateId: '5540', ProjectName: 'Crowne Pointe 4030 Building', Category: '04/06/2019', VerticalMarket: '113,000.00' });
    this.elements2.push({ EstimateId: '5541', ProjectName: 'Dever International Airport', Category: '04/10/2019', VerticalMarket: '251,000.00' });
    this.elements2.push({ EstimateId: '5542', ProjectName: 'Westwood Christian', Category: '04/12/2019', VerticalMarket: '25.00' });

    this.elements6.push({ EstimateId: '5567', ProjectName: 'Using cube resources', Category: '04/04/2019', VerticalMarket: '113,000.00' });
    this.elements6.push({ EstimateId: '5540', ProjectName: 'Crowne Pointe 4030 Building', Category: '04/06/2019', VerticalMarket: '113,000.00' });
    this.elements6.push({ EstimateId: '5541', ProjectName: 'Dever International Airport', Category: '04/10/2019', VerticalMarket: '251,000.00' });
    this.elements6.push({ EstimateId: '5542', ProjectName: 'Westwood Christian', Category: '04/12/2019', VerticalMarket: '25.00' });

    this.customScroll();

    this.searchInfoToSelect()
  }



  setGrid2() {
    let mythis = this;
    // this.customerDataSource = AspNetData.createStore({
    //   key: "ID",
    //   loadUrl: this.customerService.GetCustomerFilterUrl(),
    //   onLoaded: function (data) {
    //     let infoFinal = []
    //     data.forEach(element => {
    //       if (element.AVAILABLE) {
    //         element.AVAILABLEYesOrNo = "Yes"
    //       } else {
    //         element.AVAILABLEYesOrNo = "No"
    //       }
    //       if (element.HASCREDIT) {
    //         element.HASCREDITYesOrNo = "Yes"
    //       } else {
    //         element.HASCREDITYesOrNo = "No"
    //       }
    //       infoFinal.push(element)
    //     })
    //     data = infoFinal
    //     console.log('data loaded', data);

    //     // mythis.dataCardList = data

    //     if (!mythis.headers && data.length > 0)
    //       mythis.headers = Object.keys(data[0]);

    //     // if (data.length == 0)
    //     //   mythis.customerDataSource = [];
    //   },
    //   onBeforeSend: function (e, ajaxOptions) {
    //     console.log(e)
    //     console.log(ajaxOptions)
    //     mythis.loading = false;

    //     console.log(mythis.headers);

    //     if (ajaxOptions.data.sort) {
    //       let sort = JSON.parse(ajaxOptions.data.sort);
    //       mythis.customerFilter.OrderID = mythis.headers.indexOf(sort[0].selector);
    //       if (sort[0].desc) {
    //         mythis.customerFilter.OrderID = mythis.customerFilter.OrderID * -1;
    //       }
    //     }

    //     // mythis.filterPipeline.OrderId = mythis.filterPipeline.OrderId * -1;
    //     ajaxOptions.method = 'POST';
    //     // mythis.customerFilter.PageIndex = (ajaxOptions.data.skip / 20) == 0 ? 1 : ajaxOptions.data.skip / 20;
    //     let page = (ajaxOptions.data.skip / 20) == 0 ? 1 : ajaxOptions.data.skip / 20;
    //     mythis.customerFilter.PageIndex = ajaxOptions.data.skip ? page : mythis.customerFilter.PageIndex;

    //     let filters = Object.assign({}, mythis.customerFilter);

    //     ajaxOptions.data = JSON.stringify(filters);
    //     ajaxOptions.contentType = 'application/json';
    //     ajaxOptions.headers = {
    //       'Authorization': `Bearer ${localStorage.getItem('token')}`
    //     }
    //   }
    // });
  }

  showFilter() {
    console.log("aqui")
  }

  clearFilterCompany() {
    console.log("aqui")
  }

  searchCompany(id) {
    const data = {
      method: "Get_Customers",
      id: id
    }
    this.MapInformationService.SaveInfoSites(data).subscribe(
      // this.customerService.GetCustumerById(id).subscribe(
      data => {
        console.log('getCustumerById' + (data[0].CUSTOMERNAME));
        console.log(data)
        // CUSTOMERNAME
        this.formDataLoad(data[0]);
      },
      err => {
        console.log('Error' + err)
      }
    )
  }

  CreatedOn:any

  formDataLoad(infoCompany) {
    // Convertir en array el string
    let otherPeople;
    otherPeople = [];
    if (infoCompany.OTHESALESPERSONIDS !== '' && infoCompany.OTHESALESPERSONIDS !== null) {
      otherPeople = (infoCompany.OTHESALESPERSONIDS.split(','));
      let arryTemp;
      arryTemp = [];
      otherPeople.forEach(element => {
        arryTemp.push(parseInt(element));
      });
      otherPeople = arryTemp;
      console.log('otherPeople', otherPeople);
    } else {

    }

    console.log('Load datta form', infoCompany);
    let dateFormat = 0;
    if (infoCompany.CREATEDDATE != undefined) {
      dateFormat = new Date(infoCompany.CREATEDDATE).getTime();
    }

    this.CreatedOn = this.pipeDate.transform(infoCompany.CREATEDDATE, 'MM/dd/yyyy');

    this._formEntityEdit = new FormGroup({
      id: new FormControl({ value: infoCompany.ID, disabled: false }, []),
      customername: new FormControl({ value: infoCompany.CUSTOMERNAME, disabled: false }, [Validators.required, Validators.maxLength(45)]),
      customernumber: new FormControl({ value: infoCompany.NUMBER, disabled: false }, []),
      customertypeid: new FormControl({ value: infoCompany.CUSTOMERTYPEID, disabled: false }, []),
      offphone: new FormControl({ value: infoCompany.OFFPHONE, disabled: false }, [Validators.maxLength(20)]),
      phone2: new FormControl({ value: infoCompany.OFFPHONE2, disabled: false }, [Validators.maxLength(20)]),
      website: new FormControl({ value: infoCompany.WEBSITE, disabled: false }, []),
      offfax: new FormControl({ value: infoCompany.OFFFAX, disabled: false }, [Validators.maxLength(20)]),
      emailaddress: new FormControl({ value: infoCompany.EMAILADDRESS, disabled: false }, []),
      address: new FormControl({ value: infoCompany.ADDRESS, disabled: false }, []),
      addressline2: new FormControl({ value: infoCompany.ADDRESSLINE2, disabled: false }, []),
      city: new FormControl({ value: infoCompany.CITY, disabled: false }, []),
      employeeid: new FormControl({ value: parseInt(infoCompany.EMPLOYEEID), disabled: false }, []),
      zip: new FormControl({ value: infoCompany.ZIP, disabled: false }, []),
      state: new FormControl({ value: infoCompany.STATE, disabled: false }, []),
      country: new FormControl({ value: infoCompany.COUNTRY, disabled: false }, []),
      Billing: new FormControl({ value: 0, disabled: false }, []),
      customernotes: new FormControl({ value: infoCompany.NOTES, disabled: false }, []),
      billingname: new FormControl({ value: infoCompany.BILLINGADDRESSNAME, disabled: false }, []),
      billingaddress: new FormControl({ value: infoCompany.BILLINGADDRESS, disabled: false }, []),
      billingaddressline2: new FormControl({ value: infoCompany.BILLINGADDRESSLINE2, disabled: false }, []),
      billingcity: new FormControl({ value: infoCompany.BILLINGCITY, disabled: false }, []),
      billingzip: new FormControl({ value: infoCompany.BILLINGZIP, disabled: false }, []),
      billingstate: new FormControl({ value: infoCompany.BILLINGSTATE, disabled: false }, []),
      billingcountry: new FormControl({ value: infoCompany.BILLINGCOUNTRY, disabled: false }, []),
      othersalespersonids: new FormControl({ value: otherPeople, disabled: false }, []),
      salesregionid: new FormControl({ value: parseInt(infoCompany.SALESREGIONID), disabled: false }, []),
      hascredit: new FormControl({ value: infoCompany.HASCREDIT, disabled: false }, []),
      Available: new FormControl({ value: infoCompany.AVAILABLE, disabled: false }, []),
      salestaxid: new FormControl({ value: infoCompany.SALESTAXID, disabled: false }, [Validators.required]),
      date: new FormControl({ value: dateFormat, disabled: true }, []),
      CreateBy: new FormControl({ value: infoCompany.USERNAME, disabled: true }, []),
    });

  }

  initForm() {
    this._formEntityEdit = new FormGroup({
      id: new FormControl({ value: '', disabled: false }, []),
      customername: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(45)]),
      customernumber: new FormControl({ value: '', disabled: false }, []),
      customertypeid: new FormControl({ value: '', disabled: false }, []),
      offphone: new FormControl({ value: '', disabled: false }, [Validators.maxLength(20)]),
      phone2: new FormControl({ value: '', disabled: false }, [Validators.maxLength(20)]),
      website: new FormControl({ value: '', disabled: false }, []),
      offfax: new FormControl({ value: '', disabled: false }, [Validators.maxLength(20)]),
      emailaddress: new FormControl({ value: '', disabled: false }, []),
      address: new FormControl({ value: '', disabled: false }, []),
      addressline2: new FormControl({ value: '', disabled: false }, []),
      city: new FormControl({ value: '', disabled: false }, []),
      employeeid: new FormControl({ value: '', disabled: false }, []),
      zip: new FormControl({ value: '', disabled: false }, []),
      state: new FormControl({ value: '', disabled: false }, []),
      country: new FormControl({ value: '', disabled: false }, []),
      Billing: new FormControl({ value: 0, disabled: false }, []),
      customernotes: new FormControl({ value: '', disabled: false }, []),
      billingaddress: new FormControl({ value: '', disabled: false }, []),
      billingaddressline2: new FormControl({ value: '', disabled: false }, []),
      billingname: new FormControl({ value: '', disabled: false }, []),
      billingcity: new FormControl({ value: '', disabled: false }, []),
      billingzip: new FormControl({ value: '', disabled: false }, []),
      billingstate: new FormControl({ value: '', disabled: false }, []),
      billingcountry: new FormControl({ value: '', disabled: false }, []),
      othersalespersonids: new FormControl({ value: '', disabled: false }, []),
      salesregionid: new FormControl({ value: '', disabled: false }, []),
      hascredit: new FormControl({ value: false, disabled: false }, []),
      Available: new FormControl({ value: false, disabled: false }, []),
      date: new FormControl({ value: '', disabled: true }, []),
      salestaxid: new FormControl({ value: 3, disabled: false }, []),
      // CustomerTpeId
      CreateBy: new FormControl({ value: '', disabled: true }, []),
    });

    this._formEntityAssociatePeople = new FormGroup({
      id : new FormControl({ value: 0, disabled: false }, []),
      customerid : new FormControl({ value: this.customerID, disabled: false }, []),
      description : new FormControl({ value: '', disabled: false }, []),
      buyetypeid : new FormControl({ value: 2, disabled: false }, []),
      influenceid : new FormControl({ value: 2, disabled: false }, []),
      contactid : new FormControl({ value: 0, disabled: false }, [Validators.required]),
    })

    this._formEntityActivity = new FormGroup({
      Hour: new FormControl({ value: '', disabled: false }, [Validators.required]),
      Minute: new FormControl({ value: null, disabled: false }, [Validators.required]),
      Customer: new FormControl({ value: this.customerID, disabled: true }, []),
      CusomerActivityId: new FormControl({ value: 0, disabled: false }, []),
      EmployeeId: new FormControl({ value: 1, disabled: false }, []),
      Type: new FormControl({ value: 1, disabled: false }, [Validators.required]),
      Notes: new FormControl({ value: '', disabled: false }, []),
      StartTime: new FormControl({ value: new Date().getTime(), disabled: false }, [Validators.required]),
      FOLLOWUPDATE: new FormControl({ value: '', disabled: false }, []),
      Follow: new FormControl({ value: '', disabled: false }, []),
      Name: new FormControl({ value: '', disabled: false }, [Validators.required]),
      Closed: new FormControl({ value: '', disabled: false }, []),
      FollowComments: new FormControl({ value: '', disabled: false }, []),
      durationDetail: new FormControl({ value: '00:00', disabled: false }, []),
    });
  }

  searchInfoToSelect() {
    this.customerService.GetCustomerType().subscribe(result => {
      console.log(result)
      this.customerTypeSelect = result.map((val) => {
        return { // Return the new object structure
          label: val.CUSTOMERTYPE,
          value: val.ID
        };
      });
      // this.MapInformationService.SaveInfoSites({method:""}).subscribe(
      this.customerService.GetCustomerSalesRegion().subscribe(
        data => {
          this.optionsRegion = data.map((val) => {
            return { // Return the new object structure
              label: val.SALESREGION,
              value: val.ID
            };
          });
          this.viewDashboardType = 2
        }
      );
      this.generalService.GetSalesPerson().subscribe(
        data => {
          console.log(data)
          this.optionsSalesPerson = data.map((val) => {
            console.log('COntacts',val)
            return { // Return the new object structure
              label: val.CONTACTNAME,
              value: val.ID
            };
          });
          this.MapInformationService.SaveInfoSites({ method: 'Get_Taxs' }).subscribe(
            // this.customerService.GetCustomerTaxes().subscribe(
            data => {
              console.log(data)
              this.optionsTax = data.map((val) => {
                if (val.TAX != undefined)
                  return { // Return the new object structure
                    label: val.TAX,
                    value: val.ID
                  };
              });
              // this.customerID = this.dataCardList[0].ID
              this.searchCompany(this.customerID)
              this.customScroll()
            }
          );
        }
      );
    });
    // })
  }
  PopupNewAssociatePeopple: boolean = false
  PopupNewActivity: boolean = false
  OpenNewAssociatePeopple() {
    let mythis = this
    this.contactDataSource = []
    this.contactDataSource = new CustomStore({
      key: "ID",
      useDefaultSearch: false,
      load: function (loadOptions: any) {
        if (loadOptions.searchValue == "" || loadOptions.searchValue == undefined) {
          loadOptions.searchValue = " "
        } else {
          loadOptions.searchValue = loadOptions.searchValue
        }
        return mythis.MapInformationService.GetAllInfoDinamico("Get_ContactsByName",loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            console.log(data);
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });
    this.PopupNewAssociatePeopple = true
  }


  OpenNewActivity() {
    this.PopupNewActivity = true
  }

  CloseNewActivity() {
    this.PopupNewActivity = false
    this._formEntityActivity = new FormGroup({
      Hour: new FormControl({ value: '', disabled: false }, [Validators.required]),
      Minute: new FormControl({ value: null, disabled: false }, [Validators.required]),
      Customer: new FormControl({ value: this.customerID, disabled: true }, []),
      CusomerActivityId: new FormControl({ value: 0, disabled: false }, []),
      EmployeeId: new FormControl({ value: 1, disabled: false }, []),
      Type: new FormControl({ value: 1, disabled: false }, [Validators.required]),
      Notes: new FormControl({ value: '', disabled: false }, []),
      StartTime: new FormControl({ value: new Date().getTime(), disabled: false }, [Validators.required]),
      FOLLOWUPDATE: new FormControl({ value: '', disabled: false }, []),
      Follow: new FormControl({ value: '', disabled: false }, []),
      Name: new FormControl({ value: '', disabled: false }, [Validators.required]),
      Closed: new FormControl({ value: '', disabled: false }, []),
      FollowComments: new FormControl({ value: '', disabled: false }, []),
      durationDetail: new FormControl({ value: '00:00', disabled: false }, []),
    });
    this.gotoEdit = false
    this.nombreActivity = "New Activity"
  }

  durationDetail:any
  CloseNewAssociatePeopple() {
    this.contactDataSource = []
    this.newRequestBySelect.placeholder = "Select.."
    this.PopupNewAssociatePeopple = false
    this.NameContact = ""
    this._formEntityAssociatePeople = new FormGroup({
      id : new FormControl({ value: 0, disabled: false }, []),
      customerid : new FormControl({ value: this.customerID, disabled: false }, []),
      description : new FormControl({ value: '', disabled: false }, []),
      buyetypeid : new FormControl({ value: 2, disabled: false }, []),
      influenceid : new FormControl({ value: 2, disabled: false }, []),
      contactid : new FormControl({ value: '', disabled: false }, [Validators.required]),
    })
  }

  Volver() {
    if(localStorage.getItem("VolverSalesProject") != undefined){
      this.router.navigateByUrl(`/salesProject/editSales/${localStorage.getItem("VolverSalesProjectID")}`);
    } else if (localStorage.getItem("VolverEditProjectContract") != undefined) {
      this.router.navigateByUrl(`/editProject?numID=${localStorage.getItem("VolverEditProjectContract")}`);
    } else  {
      localStorage.setItem('DeEditRequisition',"EditRequisition")
      this.location.back();
      // this.router.navigateByUrl(`/customers`)
    }

    localStorage.removeItem("VolverSalesProject")
    localStorage.removeItem("VolverSalesProjectID")
    localStorage.removeItem("VolverEditProjectContract")

  }

  getAllCompanies() {
    const data = {
      method: ""
    }
  }

  DeleteCompany(item) {
    console.log(item)
  }

  ShowInfoCompany(item) {
    this.customerID = item.CUSTOMERID
    this.searchCompany(item.CUSTOMERID)
  }

  handleValueChange(event){
    console.log(event)
    if(event.value){
      console.log(this._formEntityEdit.value)
      this._formEntityEdit.get("billingaddress").setValue(this._formEntityEdit.value.address)
      this._formEntityEdit.get("billingcity").setValue(this._formEntityEdit.value.city)
      this._formEntityEdit.get("billingzip").setValue(this._formEntityEdit.value.zip)
      this._formEntityEdit.get("billingstate").setValue(this._formEntityEdit.value.state)
      this._formEntityEdit.get("billingcountry").setValue(this._formEntityEdit.value.country)
      this._formEntityEdit.get("billingaddressline2").setValue(this._formEntityEdit.value.addressline2)
    } else {
      this._formEntityEdit.get("billingaddress").setValue("")
      this._formEntityEdit.get("billingcity").setValue("")
      this._formEntityEdit.get("billingzip").setValue("")
      this._formEntityEdit.get("billingstate").setValue("")
      this._formEntityEdit.get("billingcountry").setValue("")
      this._formEntityEdit.get("billingaddressline2").setValue("")
    }
  }

  submitForm() {
    let formValue;
    formValue = this._formEntityEdit.value;
    formValue = { CustomerId: this._formEntityEdit.value.id, ...formValue };
    console.log('formValue', formValue);
    //Coverit a string Other sales person seprados por coma
    let ArraystrinOtherSlaesPerosn: string;
    // Same Address

    if (formValue.Billing === 0) {
      // delete formValue.BillingAddress
      formValue = { customeraddresssame: 'false', ...formValue };
    } else {
      console.log("aqui")
      //  Error: El servicio no esta guardandolos campos a continuacion
      formValue.billingaddress = formValue.address;
      formValue.billingcity = formValue.city;
      formValue.billingzip = formValue.zip;
      formValue.billingstate = formValue.state;
      formValue.billingcountry = formValue.country;
      formValue.billingaddressline2 = formValue.addressline2;
      // Se implementa el siguiente campo customeraddresssame
      formValue = { customeraddresssame: 'true', ...formValue };
    }

    ArraystrinOtherSlaesPerosn = '';
    if (formValue.hascredit === true) {
      formValue.hascredit = 1
    } else {
      formValue.hascredit = 0
    }
    if (formValue.Available === true) {
      formValue.Available = 1
    } else {
      formValue.Available = 0
    }
    if (formValue.othersalespersonids.length > 0) {
      let i = 0;
      formValue.othersalespersonids.forEach(element => {
        if (i === 0) {
          ArraystrinOtherSlaesPerosn = element;
        } else {
          ArraystrinOtherSlaesPerosn = ArraystrinOtherSlaesPerosn + ',' + element;
        }
        i++;
      });
      formValue.othersalespersonids = ArraystrinOtherSlaesPerosn
      console.log('formValue 2', formValue);
    } else {
      // Vacio
      formValue.othersalespersonids = "";
    }
    formValue.customergoogleadd = formValue.address



    // if(formValue.billingaddress != undefined){
    //   if (formValue.billingaddress.length > 14 || formValue.address.length > 14) {
    //     let primeraparteAddressBilling = formValue.billingaddress.slice(0, formValue.billingaddress.length / 2)
    //     let segundaparteAddressBilling = formValue.billingaddress.slice(formValue.billingaddress.length / 2)

    //     let primeraparteAddress = formValue.address.slice(0, formValue.address.length / 2)
    //     let segundaparteAddress = formValue.address.slice(formValue.address.length / 2)

    //     formValue.address = primeraparteAddress
    //     formValue.addressline2 = segundaparteAddress
    //     formValue.billingaddress = primeraparteAddressBilling
    //     formValue.billingaddressline2 = segundaparteAddressBilling
    //   } else {
    //     formValue.addressline2 = ""
    //     formValue.billingaddressline2 = ""
    //   }
    // }

    delete formValue.Billing;
    formValue.method = "Insert_Customer"
    console.log(formValue)
    this.MapInformationService.SaveInfoSites(formValue).subscribe(
      // this.customerService.EditCustumerById(formValue).subscribe(
      data => {
        console.log(data);
        this.toast.success('Customer Edited Successfully');
      },
      err => {
        console.log(err)
      }
    )
  }

  Activity: any[] = []
  AssociatePeopple: any[] = []

  titleClick(e) {
    console.log(e.itemData.title)
    switch (e.itemData.title) {
      case 'Activity':
        console.log("aqui")
        this.getActivity()
        break
      case 'Associate People':
        console.log("aqui")
        this.getAssociatePeople()
        break
    }
  }

  optionsType: any[] = []
  optionsInfluence: any[] = []
  optionsPeopleAsc: any[] = []
  optionsPeople: any[] = []

  getActivity() {
    const data = {
      method: "Get_Customer_Activities",
      customerid:this.customerID
      // customerid: "1164"
    }
    this.MapInformationService.SaveInfoSites(data)
      // this.customerService.GetCustomerActivityEmployeesFilter({})
      .subscribe(resp => {
        console.log(resp)
        let infoFinal = []
        resp.forEach(element=>{
          let duration = ""
          if(element.DURATION != undefined){
            duration = element.DURATION.toString().split(".")
            if(duration[1] == undefined){
              console.log(duration[0].length)
              if(duration[0].length == 2){
                duration = duration[0]+":"+"00"
              } else {
                duration = "0"+duration[0]+":"+"00"
              }
            } else {
              if(duration[0].length == 2){
                if(duration[1].length == 2){
                  duration = duration[0]+":"+duration[1]
                } else {
                  duration = duration[0]+":"+duration[1]+"0"
                }
              } else {
                if(duration[1].length == 2){
                  duration = "0"+duration[0]+":"+duration[1]
                } else {
                  duration = "0"+duration[0]+":"+duration[1]+"0"
                }
              }
            }
          }
          element.DURATION = duration
          infoFinal.push(element)
        })
        console.log(infoFinal)
        this.Activity = infoFinal


        this.customerService.GetCustomerActivityEmployees().subscribe(
          data => {
            this.optionsPeople = data.map((val) => {
              // console.log(val.value)
              return { // Return the new object structure
                label: val.value,
                value: val.ID
              };
            });
            console.log(this.optionsPeople)
          })
        this.customerService.GetCustomerActivityType().subscribe(
          data => {
            this.optionsCType = data.map((val) => {
              console.log(val.value)
              return { // Return the new object structure
                label: val.Name,
                value: val.ID
              };
            });
          },
          err => {
            console.log(err)
          }
        );
      })
  }

  getInfoActivity(){
    this.customerService.GetCustomerActivityType().subscribe(
      data => {
        this.optionsCType = data.map((val) => {
          console.log(val.value)
          return { // Return the new object structure
            label: val.Name,
            value: val.ID
          };
        });
      },
      err => {
        console.log(err)
      }
    );
  }


  contactDataSource:any
  getAssociatePeople() {
    const info = {
      method: "Get_Customer_Contacts",
      customerid:this.customerID
      // customerid: "1164"
    }
    this.MapInformationService.SaveInfoSites(info)
      .subscribe(resp => {
        console.log(resp)
        this.AssociatePeopple = resp.filter((valor, indice) => {
          return valor.CONTACTID != undefined;
        }
      );
        this.customerService.GetCustomerBuyerType().subscribe(result => {
          this.optionsType = result.map((val) => {
            return { // Return the new object structure
              label: val.DESCRIPTION,
              value: val.ID
            };
          });
          console.log(this.optionsType)
          this.customerService.GetCustomerOportunityInfluence().subscribe(result => {
            this.optionsInfluence = result.map((val) => {
              return { // Return the new object structure
                label: val.DESCRIPTION,
                value: val.ID
              };
            });
            // this.customerService.GetContactsPeople().subscribe(result => {
            //   if (this.optionsPeopleAsc.length == 0) {
            //     this.optionsPeopleAsc = result.map((val) => {
            //       return { // Return the new object structure
            //         label: val.First + ' ' + val.Last,
            //         value: val.ID
            //       };
            //     });
            //     console.log(this.optionsPeopleAsc)
            //   }
            // });
            let mythis = this
            // this.contactDataSource = new CustomStore({
            //   key: "ID",
            //   useDefaultSearch: false,
            //   load: function (loadOptions: any) {
            //     if (loadOptions.searchValue == "" || loadOptions.searchValue == undefined) {
            //       loadOptions.searchValue = " "
            //     } else {
            //       loadOptions.searchValue = loadOptions.searchValue
            //     }
            //     return mythis.MapInformationService.GetAllInfoDinamico("Get_ContactsByName",loadOptions.searchValue)
            //       .toPromise()
            //       .then((data: any) => {
            //         console.log(data);
            //         return data;
            //       })
            //       .catch(error => { throw 'Data Loading Error' });
            //   }
            // });
          });
        });
      })
  }

  SaveNewActivity() {
    let formValue;
    console.log(this._formEntityActivity.value)
    formValue = this._formEntityActivity.value;

    formValue.OptCustomer = 1;
    formValue.OptServiceSite = 0;
    formValue.OptProject = 0;

    // formValue.CustomerId = parseInt(this.customerID);
    formValue.Customer = parseInt(this.customerID);

    // Change Format date 2020-07-16 to 20200715 11:11 (Concat hour)
    let TMPdate;
    let HourToedit;

    HourToedit = formValue.Hour;
    formValue.StartTime = new Date(formValue.StartTime);
    formValue.FOLLOWUPDATE = new Date(formValue.FOLLOWUPDATE);

    formValue.Hour = formValue.durationDetail.substr(0, 2);
    formValue.Minute = formValue.durationDetail.substr(2, 5);

    if(parseInt(formValue.Minute) > 60){
      this.toast.warning("The minutes cannot be greater than 60")
      return false
    }

    if (formValue.Follow == true) {
      formValue.Follow = parseInt('1');
    } else { formValue.Follow = parseInt('0'); }
    // Close
    if (formValue.Closed == true) {
      formValue.Closed = parseInt('1');
    } else { formValue.Closed = parseInt('0'); }
    // END hange boolean ton strin 0 and 1
    if (formValue.Name === "") {
      formValue.Name = "New Activity";
    }

    formValue.Employee = formValue.EmployeeId
    formValue.ActivityType = formValue.Type

    if(this.gotoEdit){

      if (formValue.Follow == true) {
        formValue.Follow = parseInt('1');
      } else { formValue.Follow = parseInt('0'); }
      // Closed
      if (formValue.Closed == true) {
        formValue.Closed = parseInt('1');
      } else { formValue.Closed = parseInt('0'); }
      // END hange boolean ton strin 0 and 1
      if (formValue.Name === "") {
        formValue.Name = "New Activity";
      }

      const infoFinal = {
        Hour:formValue.Hour,
        Minute: formValue.Minute,
        ActivityType:formValue.Type,
        Closed:formValue.Closed,
        Customer: parseInt(this.customerID),
        Employee:formValue.EmployeeId,
        FollowUp:formValue.Follow,
        Name:formValue.Name,
        Description:formValue.Notes == undefined ? "": formValue.Notes,
        OptCustomer:1,
        OptProject:0,
        OptServiceSite:0,
        Project:0,
        ServiceSite:0,
        StartTime:formValue.StartTime,
        activityid:formValue.Id,
        method:"UpdateActivity",
        followupdate:formValue.FOLLOWUPDATE,
        FollowUpComments: formValue.FollowComments == undefined ? "":formValue.FollowComments,
      }
      formValue = infoFinal
    } else {
      formValue.Description = formValue.Notes
      formValue.FollowUpComments = formValue.FollowComments
      formValue.followupdate = formValue.FOLLOWUPDATE
      formValue.method ="SaveActivity"
    }

    console.log(formValue)
    // this.MapInformationService.getParameters("UpdateActivity")
    // .subscribe(resp=>{
    //   console.log(resp)
    // })
    this.MapInformationService.SaveInfoSites(formValue).subscribe(
      data => {
        this.toast.success('Activity Created Successfully');
        this.CloseNewActivity()
        this.getActivity()
        this.gotoEdit = false
        this.nombreActivity = "New Activity"
      })

  }


  editActivity(data) {
    let formValue;
    formValue = this._formEntityActivity.value;
    formValue.Follow = data.data.FOLLOWUP
    formValue.Closed = data.data.CLOSED1

    if (formValue.Follow === true) {
      formValue.Follow = parseInt('1');
    } else { formValue.Follow = parseInt('0'); }
    // Closed
    if (formValue.Closed === true) {
      formValue.Closed = parseInt('1');
    } else { formValue.Closed = parseInt('0'); }
    // END hange boolean ton strin 0 and 1
    if (formValue.Name === "") {
      formValue.Name = "New Activity";
    }
    console.log(data)

    let hour = data.data.DURATION.substr(0, 2);
    let minute = data.data.DURATION.substr(2, 5);
    if (hour.length == 1){
      hour = "0"+hour
    }
    if (minute.length == 1){
      minute = minute+"0"
    }

    if (parseInt(minute) > 60 ){
      this.toast.warning("The minutes cannot be greater than 60")
      this.getActivity()
      return false
    }
    formValue.Hour = hour
    formValue.Minute = minute

    console.log(data)
    const infoFinal = {
      Hour:formValue.Hour,
      Minute: formValue.Minute,
      ActivityType:data.data.TYPE,
      Closed:formValue.Closed,
      Customer: this.customerID,
      Employee:data.data.EMPLOYEEID,
      FollowUp:formValue.Follow,
      Name:data.data.NAME,
      Notes:data.data.NOTES == undefined ? "": data.data.NOTES,
      OptCustomer:1,
      OptProject:0,
      OptServiceSite:0,
      Project:0,
      ServiceSite:0,
      StartTime:data.data.DATE,
      activityid:data.data.ID,
      method:"UpdateActivity",
      FollowUpComments: data.data.FOLLOWUPCOMMENTS == undefined ? "":data.data.FOLLOWUPCOMMENTS,
    }
    console.log(infoFinal)
    this.MapInformationService.SaveInfoSites(infoFinal).subscribe(
    // this.customerService.PostInsertUpdateCustomerActivity(infoFinal).subscribe(
      data => {
        this.toast.success('Activity Edited Successfully');
        this.getActivity()
      },
      err => {
        console.log(err)
      }
    )
  }

  SaveNewAssociatePeople() {
    this._formEntityAssociatePeople.value.method="Insert_MultipleCustomer_To_Contacts"
    this._formEntityAssociatePeople.value.customerid = this.customerID
    console.log(this._formEntityAssociatePeople.value)
    this.MapInformationService.SaveInfoSites(this._formEntityAssociatePeople.value).subscribe(
    // this.customerService.PostInsertCustomerContacts(this._formEntityAssociatePeople.value).subscribe(
      data => {
        console.log(data)
        // if (data[0].Result) {
          this.toast.success('Associate People Created Successfully');
          this.CloseNewAssociatePeopple();
          this.getAssociatePeople()
          this.contactDataSource = []
          this.newRequestBySelect.placeholder = "Select.."
        // } else {
        //   this.toast.error('Error Creating Associate People');
        // }
      },
      err => {
        console.log(err)
      }
    )
    this.contactDataSource = []
  }

  InicioEditPeople(event){
    let mythis = this
    this.contactDataSource = new CustomStore({
      key: "ID",
      useDefaultSearch: false,
      load: function (loadOptions: any) {
        if (loadOptions.searchValue == "" || loadOptions.searchValue == undefined) {
          loadOptions.searchValue = " "
        } else {
          loadOptions.searchValue = loadOptions.searchValue
        }
        return mythis.MapInformationService.GetAllInfoDinamico("Get_ContactsByName",loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            console.log(data);
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });
  }

  editAssociatePeopple(data) {
    console.log(data)
    const info = {
      id: data.data.ID,
      customerid:this.customerID,
      // CustomerId: "1164",
      description: data.data.DESCRIPTION,
      buyertypeId: data.data.BUYERTYPEID == undefined ? 0 : data.data.BUYERTYPEID,
      infuenceid: data.data.INFLUENCEID,
      contactid: data.data.CONTACTID,
      method:"Insert_MultipleCustomer_To_Contacts"
    }

    console.log(info)
    this.customerService.EditInsertCustomerContacts(info).subscribe(
      data => {
        console.log(data)
        if (data[0].Result) {
          this.toast.success('Edit Associate People Successfully');
          this.getAssociatePeople()
        } else {
          this.toast.error('Error Edited Associate People');
        }
      },
      err => {
        console.log(err)
      }
    )
    this.contactDataSource = []
    console.log(data)
  }

  DeleteADocument(event){
    console.log(event)
    let info = {
      method:"Delete_Customer_Contacts",
      customerid:this.customerID,
      contactid:event.key.CONTACTID,
    }
    console.log(info)
    this.MapInformationService.SaveInfoSites(info)
    .subscribe(resp=>{
      this.toast.success("Registry deleted successfully")
      this.getAssociatePeople()
    })
  }

  handleAddressChange(event) {
    console.log(event.address_components)
    console.log(event)
    for (let i = 1; i < event.address_components.length; i++) {
      let test = event.address_components[i];
      console.log(test)
      if (test.long_name != '') {
        if (test.types[0] == "street_number") {
          this.houseNumber = test.long_name;
        }
        if (test.types[0] == "route") {
          this.street = test.long_name;
        }
        if (test.types[0] == "locality") {
          this.mapCity = test.long_name;
        }
        if (test.types[0] == "administrative_area_level_1") {
          this.mapState = test.short_name;
          // this.mapState = test.long_name;
        }
        if (test.types[0] == "country") {
          this.mapcountry = test.long_name;
        }
        if (test.types[0] == "postal_code") {
          this.mapPaostalCode = test.long_name;
        }
        let streets = this.street && this.houseNumber ? (this.houseNumber + ', ' + this.street) : '';
        test = streets ? streets : this.street;
        console.log(test)
      }
    }
    this._formEntityEdit.get('address').setValue(event.formatted_address)
    this._formEntityEdit.get('city').setValue(this.mapCity)
    this._formEntityEdit.get('zip').setValue(this.mapPaostalCode)
    this._formEntityEdit.get('country').setValue(this.mapcountry)
    this._formEntityEdit.get('state').setValue(this.mapState)
  }

  handleAddressChangeBilling(event) {
    for (let i = 1; i < event.address_components.length; i++) {
      let test = event.address_components[i];
      console.log(test)
      if (test.long_name != '') {
        if (test.types[0] == "street_number") {
          this.houseNumberBilling = test.long_name;
        }
        if (test.types[0] == "route") {
          this.streetBilling = test.long_name;
        }
        if (test.types[0] == "locality") {
          this.mapCityBilling = test.long_name;
        }
        if (test.types[0] == "administrative_area_level_1") {
          this.mapStateBilling = test.short_name;
          // this.mapStateBilling = test.long_name;
        }
        if (test.types[0] == "country") {
          this.mapcountryBilling = test.long_name;
        }
        if (test.types[0] == "postal_code") {
          this.mapPaostalCodeBilling = test.long_name;
        }
        let streets = this.streetBilling && this.houseNumberBilling ? (this.houseNumberBilling + ', ' + this.streetBilling) : '';
        test = streets ? streets : this.streetBilling;
      }
    }
    this._formEntityEdit.get('billingaddress').setValue(event.formatted_address)
    this._formEntityEdit.get('billingcity').setValue(this.mapCityBilling)
    this._formEntityEdit.get('billingzip').setValue(this.mapPaostalCodeBilling)
    this._formEntityEdit.get('billingcountry').setValue(this.mapcountryBilling)
    this._formEntityEdit.get('billingstate').setValue(this.mapStateBilling)

  }

  getInitials(str) {
    return this.generalService.getInitials(str);
  }

  clearFilter() {
    this.customerFilter = {
      PageIndex: 1,
      PageSize: 20,
      OrderID: 1,
      Id: 0,
      CustomerName: '',
      CustomerNumber: '',
      SalesPerson: '',
      CustomerType: '',
      SalesRegion: '',
      City: '',
      State: '',
      Zip: '',
      OfficePhone: '',
      HasCredit: '',
      Active: '',
      OffFax: ''
    };

    this.modelSalesPerson = '';
    this.modelCustomerType = '';
    this.customers = [];
    this.lastSearchZero = false;
    this.GetCustomersWithFilters(true);

  }

  goEdit(data) {
    console.log(data)
  }

  GetCustomersWithFilters(isFilter = false) {
    // if (!this.customerFilter.Id) {
    //   this.customerFilter.Id = 0;
    // }
    if (this.loading == true) { return 0; }
    this.loading = true;
    if (isFilter) {
      this.customerFilter.PageIndex = 1;
      this.lastSearchZero = false;
      this.customerFilter.SalesPerson = this.modelSalesPerson ? this.modelSalesPerson.join(',') : '';
      this.customerFilter.CustomerType = this.modelCustomerType ? this.modelCustomerType.join(',') : '';
    }
    localStorage.setItem('customerFilter', JSON.stringify(this.customerFilter));

    this.setGrid2();
    // this.customerService.GetCustomerFilters(this.customerFilter).subscribe(result => {
    //   this.customerFilter.PageIndex++;
    //   this.loading = false;

    //   if (result.length > 0) {
    //     if (isFilter) {
    //       this.customers = result;
    //     } else {

    //       const tempCopy = JSON.parse(JSON.stringify(this.customers));

    //       result.forEach(element => {
    //         tempCopy.push(element);
    //       });

    //       this.customers = tempCopy;
    //       // result.forEach(element => {
    //       //   this.customers.push(element);
    //       // });
    //     }
    //   } else {
    //     this.lastSearchZero = true;
    //   }

    //   if (isFilter && result.length == 0) {
    //     this.customers = [];
    //   }

    //   localStorage.setItem('customerData', JSON.stringify(this.customers));
    // });
  }

  GetSalesPerson() {
    this.generalService.GetSalesPerson().subscribe(result => {
      this.salesPersonSelect = result.map((val) => {
        return { // Return the new object structure
          label: val.CONTACTNAME,
          value: val.ID
        };
      });
    });
  }

  GetCustomerType() {
    this.customerService.GetCustomerType().subscribe(result => {
      this.customerTypeSelect = result.map((val) => {
        return { // Return the new object structure
          label: val.CUSTOMERTYPE,
          value: val.ID
        };
      });

      // console.log('ths', this.customerTypeSelect);
    });
  }

  GetCountries() {
    this.customerService.GetCountries().subscribe(result => {
      this.contrySelect = result.map((val) => {
        return { // Return the new object structure
          label: val.COUNTYNAME,
          value: val.CountryISO3
        };
      });
      console.log('');
    });
  }

  cargandoScroll: number = 0
  customScroll() {
    var mythis = this;

    $('#myScrollCustomer').on('scroll', function () {
      if (($(this).scrollTop() + $(this).innerHeight() + 100) >= $(this)[0].scrollHeight && mythis.cargandoScroll == 0) {
        if (mythis.lastSearchZero == false) {
          mythis.GetCustomersWithFilters();
          mythis.page = mythis.page + 1
          mythis.cargandoScroll = 1
          mythis.GetinfoScroll()
        }
      }
    });
  }


  GetinfoScroll() {
    const info = {
      method: "Get_Customers_Pagination",
      pageindex: this.page,
      pagesize: 30
    }
    this.loading = true;

    this.MapInformationService.SaveInfoSites(info)
      .subscribe(resp => {
        resp.sort(function (a, b) {
          var nameA = a.CUSTOMERNAME.toUpperCase();
          var nameB = b.CUSTOMERNAME.toUpperCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });
        resp.forEach(element => {
          this.dataCardList.push(element)
        });

        this.loading = false;
        this.cargandoScroll = 0

      })
  }
  /****************************
   * *** Modal New Custumer ***
   */
  submitFormNewCustumer(goToedit?: boolean) {
    let formValue = this._formEntity.value;
    console.log('formValue init', formValue);
    if (formValue.Billing === false || formValue.Billing === null) {
      // delete formValue.BillingAddress
      formValue = { CustomerAddressSame: 'false', ...formValue };
    } else {
      //  Error: El servicio no esta guardandolos campos a continuacion
      formValue.BillingAddress = formValue.Address;
      formValue.BillingCity = formValue.City;
      formValue.BillingZip = formValue.Zip;
      formValue.BillingState = formValue.State;
      formValue.BillingCountry = formValue.Country;
      // Se implementa el siguiente campo CustomerAddressSame
      formValue = { CustomerAddressSame: 'true', ...formValue };
    }
    console.log('formValue Crear', formValue);
    delete formValue.Billing;
    // save
    this.customerService.PostNewCustumer(formValue).subscribe(
      data => {
        console.log(data);
        // this._formEntity.reset();
        this.toast.success('Customer Created  Successfully');
        if (goToedit) {
          this.router.navigate(['/customers/editCustomer/' + data[0].Column1]);
        }
      },
      err => {
        console.log(err);
      }
    );
  }
  saveAndNew() {
    this.submitFormNewCustumer(false);
    this.clearForm();
  }
  saveAndEdit() {
    this.submitFormNewCustumer(true);
  }
  clearForm() {
    this._formEntity = this.fb.group({
      CustomerName: [null, [Validators.required, Validators.maxLength(45)]],
      CustomerNumber: [null, []],
      CustomerTpeId: [{ value: 12, disabled: false }, []],
      OffPhone: [null, [Validators.maxLength(20)]],
      OffFax: [null, [Validators.maxLength(20)]],
      WebSite: [null, []],
      Address: [null, []],
      City: [null, []],
      Zip: [null, []],
      EmployeeId: [{ value: 1, disabled: false }, []],
      State: [null, []],
      Country: [{ value: 'USA', disabled: false }, []],
      Billing: [null, []],
      Notes: [null, []],
      BillingName: [null, [Validators.maxLength(50)]],
      BillingAddress: [null, []],
      BillingCity: [null, []],
      BillingZip: [null, []],
      BillingState: [null, []],
      BillingCountry: [{ value: 'USA', disabled: false }, []],
    });
  }
  deleteCustumer() {
    console.log('deleteCustumer', this.customerSelecte);
    this.customerService.deleteCustumer(this.customerSelecte).subscribe(
      data => {
        console.log('delete custumer', data);
        this.GetCustomersWithFilters();
        this.toast.success('Company deleted Successfully');
        this.customerSelecte = null;
        this.namedeleteContacSelect = null;
      },
      err => {
        console.log(err);
        this.customerSelecte = null;
        this.namedeleteContacSelect = null;

      }
    )
  }

  ModifyHasCredit(event, data) {
    console.log(event)
    console.log(data)
    const info = {
      method: "Update_CustomerActiveHastCredit",
      active: data.data.AVAILABLE == true ? 1 : 0,
      hascredit: event.value == true ? 1 : 0,
      customerid: parseInt(data.data.CUSTOMERID)
    }
    console.log(info)
    this.MapInformationService.SaveInfoSites(info)
      .subscribe(resp => {
        this.toast.success('Has Credit Updated Successfuly')
      })
  }

  ModifyActive(event, data) {
    console.log(event)
    console.log(data)
    const info = {
      method: "Update_CustomerActiveHastCredit",
      active: event.value == true ? 1 : 0,
      hascredit: data.data.HASCREDIT == true ? 1 : 0,
      customerid: parseInt(data.data.CUSTOMERID)
    }

    this.MapInformationService.SaveInfoSites(info)
      .subscribe(resp => {
        this.toast.success('Available Updated Successfuly')
      })
  }

  NameContact:any=""

  navigateToSWO(item){
    if(item.selectedItem != undefined){
      this.NameContact = item.selectedItem.label
      this._formEntityAssociatePeople.get("contactid").setValue(item.selectedItem.ID)
    }
  }

  popupNewContact:boolean=false
  OpenNewContact(){
    this.popupNewContact = true
  }

  setNewActivityType(event){
    this._formEntityActivity.get("Type").setValue(event[0].ReturnID)
  }

  get_durations_grid(data) {
    let item = data
    if (item.includes(':')) {
      let hour = data.split(':')[0];
      let minute = data.split(':')[1];
      if (!minute) {
        minute = "00"
      }
      return hour + ':' + minute;
    } else {
      return item + ":" + "00";
    }
  }

  durationEdit:any

  InicioEdit(event){
    let duration
    if(event.data.DURATION != undefined){
      duration = event.data.DURATION.toString().split(":")
      if(duration[1] == undefined){
        console.log(duration[0].length)
        if(duration[0].length == 2){
          duration = duration[0]+"00"
        } else {
          duration = "0"+duration[0]+"00"
        }
      } else {
        if(duration[0].length == 2){
          if(duration[1].length == 2){
            duration = duration[0]+duration[1]
          } else {
            duration = duration[0]+duration[1]+"0"
          }
        } else {
          if(duration[1].length == 2){
            duration = "0"+duration[0]+duration[1]
          } else {
            duration = "0"+duration[0]+duration[1]+"0"
          }
        }
      }
    }
    this.durationEdit = duration
  }

  gotoEdit:boolean=false
  setFormActivities(val) {
    console.log(val)
    this.CloseNewActivity()
    this.getInfoActivity()
    let durat = val.DURATION ? val.DURATION.toString().split(':') : ['', ''];
    durat[0] = durat[0].padStart(2, '0');
    durat[1] = durat[1].padEnd(2, '0');
    // console.log(val)
    console.log(durat)
    // let minute = val.DURATION ? `0${val.DURATION.toString().split('.')[0]}:${val.DURATION.toString().split('.')[1]}` : '';
    let minute = durat[0] + ':' + durat[1];
    this._formEntityActivity = new FormGroup({
      Id: new FormControl({ value: val.ID, disabled: false }, []),
      OptCustomer: new FormControl({ value: 1, disabled: false }, []),
      OptServiceSite: new FormControl({ value: 0, disabled: false }, []),
      OptProject: new FormControl({ value: 0, disabled: false }, []),
      Hour: new FormControl({ value: new Date(val.DATE), disabled: false }, []),
      Minute: new FormControl({ value: minute, disabled: false }, []),
      ProjectId: new FormControl({ value: 1, disabled: false }, []),
      // CusomerActivityId: new FormControl({ value: null, disabled: false }, []),
      EmployeeId: new FormControl({ value: !val.EMPLOYEEID ? 0 : val.EMPLOYEEID, disabled: false }, []),
      Type: new FormControl({ value: val.TYPE, disabled: false }, [Validators.required]),
      Notes: new FormControl({ value: val.NOTES, disabled: false }, []),
      StartTime: new FormControl({ value: val.STARTTIME, disabled: false }, [Validators.required]),
      FOLLOWUPDATE: new FormControl({ value: val.FOLLOWUPDATE, disabled: false }, []),
      Follow: new FormControl({ value: val.FOLLOWUP == false ? 0:1, disabled: false }, []),
      Name: new FormControl({ value: val.NAME, disabled: false }, [Validators.required]),
      Closed: new FormControl({ value: val.CLOSED1 == false ? 0:1, disabled: false }, []),
      CustomerId: new FormControl({ value: 0, disabled: false }, []),
      ServiceSiteId: new FormControl({ value: 0, disabled: false }, []),
      FollowComments: new FormControl({ value: val.FOLLOWUPCOMMENTS, disabled: false }, []),
      CustomerName: new FormControl({ value: val.CustomerName, disabled: false }, []),
      durationDetail:new FormControl({ value: "00:00", disabled: false }, []),
    });

    let duration = ""
      if(val.DURATION != undefined){
        duration = val.DURATION.toString().split(":")
        if(duration[1] == undefined){
          console.log(duration[0].length)
          if(duration[0].length == 2){
            duration = duration[0]+"00"
          } else {
            duration = "0"+duration[0]+"00"
          }
        } else {
          if(duration[0].length == 2){
            if(duration[1].length == 2){
              duration = duration[0]+duration[1]
            } else {
              duration = duration[0]+duration[1]+"0"
            }
          } else {
            if(duration[1].length == 2){
              duration = "0"+duration[0]+duration[1]
            } else {
              duration = "0"+duration[0]+duration[1]+"0"
            }
          }
        }
      }
      // console.log(duration)
      this.PopupNewActivity = true;

    this._formEntityActivity.get('durationDetail').setValue(duration)
    this.gotoEdit = true
    this.nombreActivity = "Edit Activity"
    // this.now = new Date(val.DATE);

  }
  GoToContact(data){
    console.log(data)
    this.router.navigate(['/contacts/editContact/'+data.data.CONTACTID]);
  }

}
